import { nl2br } from "@newLibs/nl2br";

export function TextViewer({ content }: { content: string }) {
  return <div>{nl2br(content)}</div>;
}
